<template>
  <CCol class="customCard mb-2 p-0">
    <CCard class="col">
      <CCardHeader>
        <CCardTitle class="mt-3 py-2 d-flex justify-content-between align-items-center title">
          <slot name="title"></slot>
        </CCardTitle>
      </CCardHeader>
      <slot></slot>
    </CCard>
  </CCol>
</template>

<script>
export default {}
</script>

<style lang="scss">
.customCard {
  .card {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
  }
  .title {
    a {
      font-weight: normal;
      text-decoration: underline !important;
      font-size: 1rem;
    }
  }

  .card-body {
    border-bottom: 1px solid var(--gray-200);
  }

  ul {
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 1rem;
    }

    a {
      font-weight: normal;
      text-decoration: underline !important;
    }
  }

  svg {
    stroke: currentColor !important;
  }
}
</style>
